export default "/images/vendor/flag-icon-css/flags/4x3/yt.svg?3a98e97dfe3d47689a4fc50121523bad";